import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import "bootstrap"
import VueApexCharts from 'vue3-apexcharts'
import Datepicker from '@vuepic/vue-datepicker'
import { quillEditor } from "vue3-quill"
import rate from 'vue-rate'
import Lightbox from 'vue-easy-lightbox'
import { VueMasonryPlugin } from 'vue-masonry'
import Multiselect from 'vue-multiselect'
import { i18n } from './core/data/i18n'
import Breadcrumbs from './layouts/BreadCrumbs.vue'
import {PerfectScrollbar} from 'vue3-perfect-scrollbar'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { FormWizard, TabContent } from 'vue3-form-wizard'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBan, faCheck, faChevronDown, faCog, faEdit, faFile, faFileArchive, faFileDownload, faFileExcel, faFileImage,
  faFilePdf, faFileWord, faImage, faPlus, faSearch } from '@fortawesome/free-solid-svg-icons'
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import myUpload from 'vue-image-crop-upload/upload-3.vue'
import VueKonva from 'vue-konva'
import veProgress from 'vue-ellipse-progress'
import v3lc from 'vue3-line-clamp'

import './assets/fonts/iconsmind-s/css/iconsminds.css'
import './assets/fonts/simple-line-icons/css/simple-line-icons.css'
import './assets/scss/app.scss'
import '@vuepic/vue-datepicker/dist/main.css'
import 'vue-rate/dist/vue-rate.css'
import 'vue-multiselect/dist/vue-multiselect.css'
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css'
import 'vue3-form-wizard/dist/style.css'
import './assets/scss/nero.scss'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

library.add(faBan, faCheck, faChevronDown, faCircleXmark, faCog, faEdit, faFile, faFileArchive, faFileDownload, faFileExcel,
  faFileImage, faFilePdf, faFileWord, faImage, faPlus, faSearch)

createApp(App)
  .use(router)
  .use(pinia)
  .use(i18n)
  .use(VueApexCharts)
  .use(quillEditor)
  .use(rate)
  .use(Lightbox)
  .use(VueMasonryPlugin)
  .use(VueKonva)
  .use(veProgress)
  .use(v3lc)
  .component('PerfectScrollbar', PerfectScrollbar)
  .component('Breadcrumbs', Breadcrumbs)
  .component('Datepicker', Datepicker)
  .component('multiselect', Multiselect)
  .component('font-awesome-icon', FontAwesomeIcon)
  .component('my-upload', myUpload)
  .component('FormWizard', FormWizard)
  .component('TabContent', TabContent)
  .mount('#app')